/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SortBy {
    ID = 'id',
    CREATED_AT = 'created_at',
    FILE_TYPE = 'file_type',
    TASK_TYPE = 'task_type',
    STATUS = 'status',
    NAME = 'name',
}
